import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AppContainer from "../../../components/AppContainer";
import AppLoader from "../../../components/AppLoader";
import NavigationDrawer from "../../../components/NavigationDrawer";
import GlobalTable from "../../../components/Tables/GlobalTable";
import { setSearchKeys } from "../../../lib/slices/search_key_slice";
import { getWorkerReviews } from "../../../services/worker/authenticationApiFn";
import { handleOpenSnackBar } from "../../../utils";
import useDebounce from "./../../../components/hooks/useDebounce";
import { t } from "i18next";

const headerData = ["reviewedAt", "service", "userDetails"];

const tableRows = [
  "created_date",
  "worker_review_service",
  "worker_review_user",
];

const WorkerReviews = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [allReviews, setAllReviews] = useState([]);
  const userData = useSelector((state) => state.userData.user);
  const searchKey = useSelector((state) => state.SearchKeysReducer.searchKeys);
  const debouncedSearchTerm = useDebounce(
    searchKey.workerReviewsByUsername,
    1000
  );

  useEffect(() => {
    if (userData) {
      fetchAllReviews(debouncedSearchTerm);
    }
  }, [userData, debouncedSearchTerm]);

  const fetchAllReviews = async (name) => {
    try {
      setIsLoading(true);
      const response = await getWorkerReviews(userData?._id, name);
      if (response.data.status === "success") {
        const data = response.data.data;
        setAllReviews(data);
      } else {
        handleOpenSnackBar("error", response.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearchChange = (e) => {
    dispatch(
      setSearchKeys({
        ...searchKey,
        workerReviewsByUsername: e.target.value,
      })
    );
  };

  return (
    <NavigationDrawer>
      <AppLoader isVisible={isLoading} />
      <AppContainer
        primaryHeading={t("allReviews")}
        secondaryHeading={t("viewClientReviews")}
        showSerach={true}
        searchValue={searchKey.workerReviewsByUsername}
        onChange={handleSearchChange}
      >
        <GlobalTable
          tableHeader={headerData}
          displayRows={tableRows}
          tableData={allReviews || []}
        />
      </AppContainer>
    </NavigationDrawer>
  );
};

export default WorkerReviews;
